import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { IServicioBrindado } from '../models/serviciobrindado';

@Injectable({
  providedIn: 'root'
})
export class ServiciobrindadoService {
  private apiUrl: string ='';
  constructor(private http: HttpClient) { 
    this.apiUrl = environment.sUrlNomina + 'ServicioBrindado';
  }

  getListado(): Observable<IServicioBrindado[]> {
    return this.http
      .get<IServicioBrindado[]>(this.apiUrl)
      .pipe(retry(1), catchError(this.handleError));
  }

  public agregar(data: IServicioBrindado ):Observable<any>{
    const headers = { 'content-type': 'application/json'}  
    const body = JSON.stringify(data); 
    return this.http.post<any>(this.apiUrl,body,{'headers':headers});
   }

   public editar(data: IServicioBrindado ):Observable<any>{
    const headers = { 'content-type': 'application/json'}  
    const body = JSON.stringify(data); 
    return this.http.put<any>(this.apiUrl,body,{'headers':headers});
   }

   public estatus(data: IServicioBrindado ):Observable<any>{
    const headers = { 'content-type': 'application/json'}  
    const body = JSON.stringify(data); 
    return this.http.put<any>(this.apiUrl+'/editarStatus',body,{'headers':headers});
   }

  handleError(error:any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(() => {
        return errorMessage;
    });
  }
}
